import { faArrowRotateRight, faEye } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, Text, TextButton } from '@modusign/design-system';

type Tab = 'form' | 'draft';

interface DraftEditorSidebarProps {
  headings: Array<{ text: string; id: string }>;
  tab: Tab;
  originatedFromForm?: boolean;
  onTabChange: (mode: Tab) => void;
  onPreviewClick: () => void;
  onResetClick: () => void;
}

export default function DraftEditorSidebar({
  headings,
  tab,
  originatedFromForm,
  onTabChange,
  onPreviewClick,
  onResetClick,
}: DraftEditorSidebarProps) {
  return (
    <Flex
      alignSelf="flex-start"
      as="aside"
      bg="navigationBackgroundNeutralLight"
      borderRight="1px solid"
      borderRightColor="navigationBorderNeutralSlightlyLight"
      flexDirection="column"
      position="sticky"
      top="0"
      width="280px"
    >
      <Flex p={6}>
        {originatedFromForm && (
          <Text
            as="button"
            color={tab === 'form' ? 'textNeutralBase' : 'textNeutralVeryLight'}
            fontSize="sm"
            fontWeight="medium"
            mr={4}
            onClick={() => onTabChange('form')}
          >
            서식 원문
          </Text>
        )}
        <Text
          as="button"
          color={tab === 'draft' ? 'textNeutralBase' : 'textNeutralVeryLight'}
          fontSize="sm"
          fontWeight="medium"
          onClick={() => onTabChange('draft')}
        >
          서식 편집
        </Text>
      </Flex>
      {tab === 'form' && (
        <Box
          borderTop="1px solid"
          borderTopColor="navigationBorderNeutralSlightlyLight"
          pt={7}
          px={6}
        >
          <Text as="div" color="textNeutralVeryLight" fontSize="sm" fontWeight="medium" mb="20px">
            목차
          </Text>
          <Box as="ol" ml={3}>
            {headings.map(({ text: content, id }) => (
              <li key={id}>
                <Text
                  as="button"
                  color="textNeutralSlightlyLight"
                  fontWeight="medium"
                  mb={4}
                  textAlign="left"
                  onClick={() => {
                    window.scrollTo({
                      top: document.getElementById(id)?.offsetTop,
                      behavior: 'smooth',
                    });
                  }}
                >
                  {content}
                </Text>
              </li>
            ))}
          </Box>
        </Box>
      )}
      {tab === 'draft' && (
        <Box
          as="ul"
          borderTop="1px solid"
          borderTopColor="navigationBorderNeutralSlightlyLight"
          pt={7}
          px={6}
        >
          <li>
            <TextButton
              color="textSeutralSlightlyLight"
              sx={{ cursor: 'pointer' }}
              textDecoration="plain"
              onClick={onPreviewClick}
            >
              <FontAwesomeIcon icon={faEye} />
              <Text ml={1}>서식 미리보기</Text>
            </TextButton>
          </li>
          {originatedFromForm && (
            <Box as="li" mt={4}>
              <TextButton
                color="textSeutralSlightlyLight"
                sx={{ cursor: 'pointer' }}
                textDecoration="plain"
                onClick={onResetClick}
              >
                <FontAwesomeIcon icon={faArrowRotateRight} />
                <Text ml={1}>내용 초기화하기</Text>
              </TextButton>
            </Box>
          )}
        </Box>
      )}
    </Flex>
  );
}
